'use strict';

const OffCanvas = {
  init() {
    // off canvas nav code
    var wrapper = document.getElementsByClassName('off-canvas')[0];
    var toggles = document.getElementsByClassName('menu-toggle');

    for(var i = 0; i < toggles.length; i++) {
      var toggle = toggles[i];

      toggle.onclick = function(event) {
        if(wrapper.classList.contains('off-canvas--open')) {
          wrapper.classList.remove('off-canvas--open');
        } else {
          wrapper.classList.add('off-canvas--open');
        }

        event.preventDefault();
      }
    }
  }
};

module.exports = OffCanvas;
